import { SR_API_ACTION_GET_HOUSEHOLDS_APPLYING_TO_LISTING } from 'api/actionTypes';

export default async function getHouseholdsApplyingToListing(
  { state, apiClient },
  { listingId, forceRefresh },
) {
  const statePath = ['householdsApplyingToListingByListingId', listingId];
  if (state.exists(statePath) && !forceRefresh) {
    return;
  }

  await apiClient.postWithState({
    action: SR_API_ACTION_GET_HOUSEHOLDS_APPLYING_TO_LISTING,
    state: state,
    payload: {
      listingId,
    },
    onSuccess(householdsApplyingToListing) {
      state.set(statePath, householdsApplyingToListing);
    },
  });
}
